import { useSnapshot } from "valtio";
import QrCodeIcon from "../../../../components/icons/QrCodeIcon";
import UserSyncOnlineIcon from "../../../../components/icons/UserSyncOnlineIcon";
import TWButton from "../../../../components/TWButton";
import { editorState } from "../../../../utils/editor";

interface SelectedGuestSummaryProps {
  eventId: string;
  selectedGuests: Set<string>;
  onBack: () => void;
  onGenerate: () => void;
  isGenerating: boolean;
}

const SelectedGuestSummary = ({
  eventId,
  selectedGuests,
  onBack,
  onGenerate,
  isGenerating,
}: SelectedGuestSummaryProps) => {
  const { eventSchedules } = useSnapshot(editorState);

  // Find the selected event
  const selectedEvent = eventSchedules.find((event) => event._id === eventId);

  return (
    <div className="px-6 pb-6 flex flex-col h-[656px]">
      {/* Stage Progress */}
      <div className="flex justify-between mb-8 font-glacial font-normal text-xs leading-[123%] tracking-normal uppercase text-gray-400">
        <span>1. SELECT EVENT</span>
        <span>2. GUESTS</span>
        <span className="text-gray-900">3. SUMMARY</span>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 font-glacial text-sm uppercase">
        {/* Event Section */}
        <div className="mb-6 flex gap-3">
          <QrCodeIcon
            className="mt-0.5"
            strokeColor="#4147D5"
            strokeWidth={1.4}
          />
          <div>
            <div className="mb-2">
              <span className="tracking-wide">EVENT</span>
            </div>
            <p>{selectedEvent?.eventType || "Traditional wedding"}</p>
          </div>
        </div>

        {/* Number of Guests Section */}
        <div className="mb-6 flex gap-3">
          <UserSyncOnlineIcon className="mt-0.5" strokeColor="#4147D5" />
          <div>
            <div className="mb-2">
              <span className="tracking-wide">NO OF GUESTS</span>
            </div>
            <p>{selectedGuests.size}</p>
          </div>
        </div>

      </div>

      <div className="flex-1 flex items-end justify-center mb-4">
        <p className="font-glacial text-xs text-gray-500 text-center">
          You can return to the previous step to change this selection.
        </p>
      </div>

      {/* Action Buttons */}
      <div className="mt-6 flex justify-around">
        <TWButton onClick={onBack} variant="secondary" className="w-32 h-10">
          BACK
        </TWButton>
        <TWButton
          onClick={onGenerate}
          variant="primary"
          className="w-32 h-10"
          disabled={isGenerating || selectedGuests.size === 0}
        >
          {isGenerating ? "GENERATING..." : `GENERATE (${selectedGuests.size})`}
        </TWButton>
      </div>
    </div>
  );
};

export default SelectedGuestSummary;
